import cn from 'classnames';
import React, { forwardRef } from 'react';
import { Icon } from 'ui';
import ReactHtml from '../../shared/ReactHtml';
import { FlipcardSideTypes } from './types';

const FlipcardSide = forwardRef(
  ({ htmlContent, imageUrl, instruction, side, flipOver, setIsOver }, ref) => {
    return (
      <div
        className={cn({ [`Flipcard-${side}`]: side })}
        ref={ref}
        tabIndex="-1"
      >
        <div
          role="button"
          className="Flipcard-flipButton"
          onClick={() => flipOver(side)}
          onFocus={() => setIsOver(true)}
          onMouseOver={() => setIsOver(true)}
          onMouseLeave={() => setIsOver(false)}
          onKeyDown={e => {
            if (e.key === 'Enter') {
              flipOver(side);
            }
          }}
          tabIndex="0"
        >
          <Icon name="flipcard_large" />
          {t('interactive.flip')}
        </div>
        <div className="Flipcard-content">
          {!!imageUrl && (
            <div className="media">
              <a
                href={imageUrl}
                data-behavior="lightbox"
                aria-label={t('lessons.editor.flipcard.content_image.label')}
              >
                <img alt="" src={imageUrl} />
              </a>
              <a
                href={imageUrl}
                className="mobile_img"
                target="_blank"
                rel="noreferrer"
              >
                <img alt="" src={imageUrl} />
              </a>
            </div>
          )}
          {!!htmlContent && (
            <ReactHtml THE_DATA_HAS_BEEN_SANITIZED>{htmlContent}</ReactHtml>
          )}
          {!!instruction && (
            <div className="Flipcard-instruction">
              <ReactHtml THE_DATA_HAS_BEEN_SANITIZED>{instruction}</ReactHtml>
            </div>
          )}
        </div>
      </div>
    );
  },
);

FlipcardSide.propTypes = FlipcardSideTypes;

export default FlipcardSide;
